import { render, staticRenderFns } from "./ModalCancelReservation.vue?vue&type=template&id=67df4ffa"
import script from "./ModalCancelReservation.vue?vue&type=script&lang=js"
export * from "./ModalCancelReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports